import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { Select, DateRangePicker, DatePicker } from 'ui/components';

import { formatDate } from 'utilities/common';

const typeOptions = [
  { value: 'vendor', label: 'Vendor' },
  { value: 'ops', label: 'Ops' },
  { value: 'general_admin', label: 'General Admin' },
];

const statusOptions = [
  { value: 'new', label: 'Baru' },
  { value: 'partial_paid', label: 'Dibayar Sebagian' },
  { value: 'paid', label: 'Lunas' },
];

const initialState = {
  due: null,
  type: null,
  periodeProject: null,
  periode: null,
  document_status: null,
};

const Filter = ({ show, onClose, ConfigTable, setCount }) => {
  const [{ due, type, periodeProject, periode, document_status }, setState] = React.useState(initialState);

  const handleFilter = async (e) => {
    if (ConfigTable?.State?.filter) {
      let x = [];
      Object.keys(ConfigTable?.State?.filter).forEach((k) => {
        if (
          ConfigTable?.State?.filter[k] &&
          k !== 'start_at'
        ) {
          x.push(k);
        }
      });
      setCount(x);
    }
  };

  const $filterDocumentStatus = (e) => {
    setState((prevState) => ({
      ...prevState,
      document_status: e,
    }));

    ConfigTable?.filter('document_status', e?.value);
    handleFilter();
  };

  const $filterType = (e) => {
    setState((prevState) => ({
      ...prevState,
      type: e,
    }));

    ConfigTable?.filter('type', e?.value);
    handleFilter();
  };

  const $filterDate = (e) => {
    setState((prevState) => ({
      ...prevState,
      due: e,
    }));

    let fm = [];
    e?.forEach((data) => fm?.push(formatDate(data, 'YYYY-MM-DD')));

    ConfigTable?.filter('date_range', fm);
    handleFilter();
  };

  const $filterPeriodeProject = (e) => {
    setState((prevState) => ({
      ...prevState,
      periodeProject: e,
    }));

    let pp = ''
    if (e) {
      pp = formatDate(e, 'YYYY-MM')
    }

    ConfigTable?.filter('periode_project', pp);
    handleFilter();
  };

  const $filterPeriode = (e) => {
    setState((prevState) => ({
      ...prevState,
      periode: e,
    }));

    let pp = ''
    if (e) {
      pp = formatDate(e, 'YYYY-MM')
    }

    ConfigTable?.filter('periode', pp);
    handleFilter();
  };

  React.useEffect(() => {
    handleFilter();

    let date = [];

    if (ConfigTable?.State?.filter?.start_at && ConfigTable?.State?.filter?.end_at) {
      date.push(new Date(ConfigTable?.State?.filter?.start_at));
      date.push(new Date(ConfigTable?.State?.filter?.end_at));
    }

    let pp = null;
    if (ConfigTable?.State?.filter?.periode_project) {
      pp = new Date(ConfigTable?.State?.filter?.periode_project)
    }

    let pi = null;
    if (ConfigTable?.State?.filter?.periode) {
      pp = new Date(ConfigTable?.State?.filter?.periode)
    }

    setState((prevState) => ({
      ...prevState,
      due: date,
      periodeProject: pp,
      periode: pi,
      loading: false,
      document_status:
        ConfigTable?.State?.filter?.document_status === 'new'
          ? statusOptions[0]
          : ConfigTable?.State?.filter?.document_status === 'partial_paid'
          ? statusOptions[1]
          : ConfigTable?.State?.filter?.document_status === 'paid'
          ? statusOptions[2]
          : null,
    }));
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Vendor</div>
          <Select.Remote
            placeholder=""
            url="/partner"
            params={{'type': 'vendor'}}
            row={(d) => {
              return { value: d?.id, label: d?.name };
            }}
            initialValue={ConfigTable?.State?.filter?.vendor_id}
            onSelected={(c) => {
              ConfigTable.filter('vendor_id', c?.id);
              handleFilter();
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Project</div>
          <Select.Remote
            placeholder=""
            url="/project"
            row={(d) => {
              return { value: d?.id, label: d?.name };
            }}
            initialValue={ConfigTable?.State?.filter?.project_id}
            onSelected={(c) => {
              ConfigTable.filter('project_id', c?.id);
              handleFilter();
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Tipe
          </div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            value={type}
            initialValue={type}
            options={typeOptions}
            onChange={$filterType}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Status
          </div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            value={document_status}
            initialValue={document_status}
            options={statusOptions}
            onChange={$filterDocumentStatus}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Periode Project
          </div>
          <DatePicker
            selectionMode="month"
            value={periodeProject}
            format="yyyy/MM"
            onChange={$filterPeriodeProject}
            isShowTrigger
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Periode
          </div>
          <DatePicker
            selectionMode="month"
            value={periode}
            format="yyyy/MM"
            onChange={$filterPeriode}
            isShowTrigger
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Tanggal Jatuh Tempo
          </div>
          <DateRangePicker
            value={due}
            placeholder=""
            onChange={$filterDate}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Customer</div>
            <Select.Remote
              placeholder=""
              url="/partner"
              params={{'type': 'customer'}}
              row={(d) => {
                return { value: d?.id, label: d?.name };
              }}
              initialValue={ConfigTable?.State?.filter?.customer_id}
              onSelected={(c) => {
                ConfigTable.filter('customer_id', c?.id);
                handleFilter();
              }}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Project</div>
            <Select.Remote
              placeholder=""
              url="/project"
              row={(d) => {
                return { value: d?.id, label: d?.name };
              }}
              initialValue={ConfigTable?.State?.filter?.project_id}
              onSelected={(c) => {
                ConfigTable.filter('project_id', c?.id);
                handleFilter();
              }}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Tipe
            </div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              value={type}
              initialValue={type}
              options={typeOptions}
              onChange={$filterType}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Status
            </div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              value={document_status}
              initialValue={document_status}
              options={statusOptions}
              onChange={$filterDocumentStatus}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Periode Project
            </div>
            <DatePicker
              selectionMode="month"
              value={periodeProject}
              format="yyyy/MM"
              onChange={$filterPeriodeProject}
              isShowTrigger
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Periode
            </div>
            <DatePicker
              selectionMode="month"
              value={periode}
              format="yyyy/MM"
              onChange={$filterPeriode}
              isShowTrigger
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Tanggal Jatuh Tempo
            </div>
            <DateRangePicker
              value={due}
              placeholder=""
              onChange={$filterDate}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
